import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';

import { DatePicker } from '@mui/x-date-pickers';
import Button from '@mui/material/Button';

import { Box } from '@mui/system';

import { getReportes } from '../../../store/fuse/reportes';
import { WrapperSearch } from './styles';

const FilterReport = (props) => {
  const [search, setSearch] = useState(null);
  const reportesData = useSelector((state) => state.fuse?.reportes?.reportes?.data) || {};
  const dispatch = useDispatch();
  const initReportes = () => dispatch(getReportes());

  const { initDateSelected, setInitDateSelected, endDateSelected, setEndDateSelected } = props;

  const cleanFilters = () => {
    setInitDateSelected(null);
    setEndDateSelected(null);
    initReportes()
  };

  return (
    <>
      <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
        Rango de fechas del reporte
      </InputLabel>

      <WrapperSearch>
        <Box sx={{ width: '50%' }}>
          <DatePicker
            onChange={(newValue) => setInitDateSelected(newValue)}
            label="Fecha de Reportes Inicial"
            defaultValue=""
            value={initDateSelected}
            renderInput={(params) => <TextField {...params} sx={{ width: '95%' }} />}
          />
        </Box>
        <Box sx={{ width: '50%' }}>
          <DatePicker
            onChange={(newValue) => setEndDateSelected(newValue)}
            label="Fecha de Reportes Final"
            defaultValue=""
            value={endDateSelected}
            renderInput={(params) => <TextField {...params} sx={{ width: '95%' }} />}
          />
        </Box>
        <Button variant="contained" color="success" onClick={cleanFilters} sx={{ fontSize: '1rem' }}>
          Limpiar Filtros
        </Button>
      </WrapperSearch>
    </>
  );
};

export default FilterReport;

